import React from 'react';
import { DollarSign, CreditCard } from 'lucide-react';

/**
 * Компонент секции параметров оплаты труда
 */
const PaymentSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <DollarSign className="w-5 h-5 mr-2 text-green-500" />
        Оплата труда
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="hourlyRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Почасовая ставка (руб/час)
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">₽</span>
            </div>
            <input
              type="number"
              id="hourlyRate"
              name="hourlyRate"
              value={formData.hourlyRate}
              onChange={handleInputChange}
              min="0"
              max="10000"
              className={`form-input pl-7 w-full ${errors.hourlyRate ? 'input-error' : ''}`}
            />
          </div>
          {errors.hourlyRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.hourlyRate}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Часовая тарифная ставка для расчета заработной платы
          </p>
        </div>
      </div>
      
      {/* Информация о расчете заработной платы */}
      <div className="mt-4 flex items-start p-3 bg-white dark:bg-gray-700 rounded-lg border border-green-200 dark:border-green-700">
        <CreditCard className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
            Расчет заработной платы
          </h4>
          <p className="text-xs text-gray-600 dark:text-gray-300">
            При расчете заработной платы учитываются базовая ставка, доплаты за ночные часы (не менее 20% по ТК РФ), 
            сверхурочную работу (первые 2 часа - 50%, последующие - 100%), работу в выходные и праздничные 
            дни (не менее чем в двойном размере). Также рассчитывается приблизительная оплата отпуска и больничного.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSection;